"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThemeProvider = exports.ThemeContext = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styledComponents = require("styled-components");
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = require("../../utils/theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var ThemeContext = _styledComponents.ThemeContext;
exports.ThemeContext = ThemeContext;
var ThemeProvider = function ThemeProvider(_a) {
  var children = _a.children,
    theme = _a.theme;
  var themeValue = (0, _react.useMemo)(function () {
    return (0, _merge.default)((0, _theme.getTheme)(), theme);
  }, [theme]);
  return (0, _jsxRuntime.jsx)(_styledComponents.ThemeProvider, __assign({
    theme: themeValue
  }, {
    children: children
  }));
};
exports.ThemeProvider = ThemeProvider;
var _default = ThemeContext;
exports.default = _default;